// Plan 06-05 Task 1 — fetch wrapper para web-admin.
//
// Copy literal de web-comite/auth-client.ts (apiFetch) — separado em arquivo
// próprio para clareza. Adiciona Bearer token + propaga X-Session-Refresh
// (sliding refresh AUTH-04). Em 401, limpa session client-side.

import { getStoredSession, setSession } from './auth-client';
import { apiUrl } from './api-base';

/** fetch wrapper that injects Bearer + auto-refreshes session on X-Session-Refresh header. */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const s = getStoredSession();
  const headers = new Headers(init.headers);
  if (s) headers.set('Authorization', `Bearer ${s.token}`);
  if (!headers.has('Content-Type') && init.body && typeof init.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }
  const resp = await fetch(apiUrl(path), { ...init, headers });
  // Sliding refresh — server emits header on every authenticated request.
  const refreshed = resp.headers.get('X-Session-Refresh');
  if (refreshed && s) {
    setSession({ ...s, token: refreshed });
  }
  if (resp.status === 401) {
    setSession(null);
  }
  return resp;
}
